import { forwardRef } from 'react';


import { Box, Link, BoxProps, Typography } from '@mui/material';
import PRSMiniLogo from 'src/assets/logo_mini.png';
import PRSLogo from 'src/assets/illustrations/logo.svg';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
  
    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
         
          width:'auto',
          height: 'auto',
          display: { lg: 'inline-flex', md: 'inline-flex', sm: 'none', xs: 'none' },
          alignSelf: { lg: 'left', md: 'left', sm: 'left', xs: 'left' },
          justifyContent: 'center', 
          alignItems: 'center',     
          ...sx,
        }}
        {...other}
      >
      
       
        <img src={PRSLogo} alt="PRS Logo" width={200} style={{ maxWidth: '100%', height: 'auto' }} />


    
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

const Ollcode = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {

    const ollcode = (
      <Box
        ref={ref}
        component="div"
        sx={{
          height: 'auto',
          display: { lg: 'inline-flex', md: 'inline-flex', sm: 'none', xs: 'none' },
          alignSelf: { lg: 'left', md: 'left', sm: 'left', xs: 'left' },
          ...sx,
        }}
        {...other}
      >
        <Typography>
          Designed and Developed by <span style={{ fontWeight: 'bold' }}>Ollcode</span>
        </Typography>
      </Box>
    );

    if (disabledLink) {
      return ollcode;
    }

    return <Link sx={{ display: 'contents' }}>{ollcode}</Link>;
  }
);

const MiniLogo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {

    const miniLogo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          width:50,
          height: "auto",
          display: 'inline-flex',
          alignSelf:{lg:"center", md:"left", sm:"left", xs:"left"},
          ...sx,
        }}
        {...other}
      >
        <img src={PRSMiniLogo} alt=''/>
      </Box>
    );

    if (disabledLink) {
      return miniLogo;
    }

    return (
      <Link sx={{ display: 'contents' }}>
        {miniLogo}
      </Link>
    );
  }
);

const LoginText = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const loginText = (
      <Box
        component="div"
        sx={{
          width: { lg: 410, md: 408, sm: 400, xs: '80%' },
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...sx,
        }}
        {...other}
      >
        <a
          href="https://placedrisk.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: '#22345B' }}
        >
          <Typography>PRS Homepage</Typography>
        </a>
        
        <a href="https://client.placedrisk.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: '#22345B' }}
        >
        <Typography>Client Portal</Typography>
        </a>
      </Box>
    );

    if (disabledLink) {
      return loginText;
    }

    return <Link sx={{ display: 'contents' }}>{loginText}</Link>;
  }
);

export { Logo, MiniLogo, Ollcode, LoginText };